import { render } from "./InventoryList.vue?vue&type=template&id=59906d68&scoped=true"
import script from "./InventoryList.vue?vue&type=script&lang=js"
export * from "./InventoryList.vue?vue&type=script&lang=js"

import "./InventoryList.vue?vue&type=style&index=0&id=59906d68&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59906d68"],['__file',"src/views/h5/luqiao/stockOrder/inventory/InventoryList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59906d68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59906d68', __exports__)) {
    api.reload('59906d68', __exports__)
  }
  
  module.hot.accept("./InventoryList.vue?vue&type=template&id=59906d68&scoped=true", () => {
    api.rerender('59906d68', render)
  })

}


export default __exports__